<template>
    <div>
        <b-modal
            id="customLotModal"
            ref="customLotModal"
            :lazy="true"
            title-tag="h2"
            title="New Lot"
        >
            <!-- Modal Form -->
            <b-form class="form-horizontal">
                <b-form-group
                    :label-for="`lot`"
                    :label-cols="4"
                    label="Lot No:"
                >
                    <b-form-input
                        id="lot"
                        v-model="data.lot"
                        placeholder="Lot Number (optional)"
                        name="lot"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    :label-for="`manufacturer`"
                    :label-cols="4"
                    label="Manufacturer:"
                >
                    <b-form-input
                        id="manufacturer"
                        v-model="data.manufacturer"
                        placeholder="Manufacturer (optional)"
                        name="manufacturer"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    :label-for="`inventory_expire`"
                    :label-cols="4"
                    label="Expiration:"
                >
                    <date-picker
                        :config="datePickerOptions"
                        v-model="data.inventory_expire"
                        placeholder="Expiration Date (optional)"
                        name="inventory_expire"
                    ></date-picker>
                </b-form-group>
                <b-form-group
                    :label-for="`lot_quantity`"
                    :label-cols="4"
                    label="Quantity:"
                >
                    <b-form-input
                        id="lot_quantity"
                        v-model="data.lot_quantity"
                        v-validate="'required'"
                        :class="{ 'border-danger': errors.has('lot_quantity') }"
                        placeholder="Quantity (required)"
                        name="lot_quantity"
                    ></b-form-input>
                </b-form-group>
            </b-form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.customLotModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button-group v-else>
                        <b-dropdown
                            v-if="!continues"
                            @click="save(false)"
                            left
                            split
                            text="Save + Done"
                            variant="primary"
                        >
                            <b-dropdown-item @click="save(true)"
                                >Save + New</b-dropdown-item
                            >
                        </b-dropdown>
                        <b-dropdown
                            v-else
                            @click="save(true)"
                            left
                            split
                            text="Save + New"
                            variant="primary"
                        >
                            <b-dropdown-item @click="save(false)"
                                >Save + Done</b-dropdown-item
                            >
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { assign } from "lodash";
export default {
    components: {},
    data() {
        return {
            loading: false,
            continues: false,
            unit_measure: "Unit(s)",
            data: {
                lot: null,
                manufacturer: null,
                inventory_expire: null,
                lot_quantity: 1
            },
            datePickerOptions: {
                format: "DD/MM/YYYY"
            }
        };
    },
    computed: {},
    watch: {},
    methods: {
        open(uom) {
            this.datePickerOptions.format = this.getDateFormat();
            if (uom) {
                this.unit_measure = uom;
            }
            this.$refs.customLotModal.show();
        },
        async save(add_new) {
            let self = this;
            self.loading = true;
            let valid = await self.$validator.validateAll();
            let text = this.getText();
            let data = {
                lot: self.data.lot ? self.data.lot : "",
                manufacturer: self.data.manufacturer
                    ? self.data.manufacturer
                    : "",
                inventory_expire: self.data.inventory_expire
                    ? self.data.inventory_expire
                    : "",
                lot_quantity: self.data.lot_quantity,
                unit_measure: self.unit_measure
            };
            data["id"] = JSON.stringify(data);
            data["text"] = text;
            if (valid) {
                self.$emit("saved", data);
            }

            if (add_new) {
                self.loading = false;
                assign(this.$data.data, this.$options.data().data);
            } else {
                self.loading = false;
                self.$refs.customLotModal.hide();
            }
        },
        getText() {
            let self = this;
            let lot = self.data.lot ? self.data.lot + "; " : "";
            let manufacturer = self.data.manufacturer
                ? "(" + self.data.manufacturer + "); "
                : "";
            let quantity = self.data.lot_quantity
                ? self.data.lot_quantity + " " + self.unit_measure
                : "";
            let inventory_expire = self.data.inventory_expire
                ? "; Expires " + self.data.inventory_expire
                : "";

            return lot + manufacturer + quantity + inventory_expire;
        },
        preventFocus() {
            let self = this;
            this.$root.$once("bv::modal::hidden", () => {
                self.$nextTick(() => {
                    self.$nextTick(() => {
                        $(self.$refs.vselect.$el).find("input").blur();
                    });
                });
            });
        }
    }
};
</script>
